import { render, staticRenderFns } from "./KorrespondenzTemplate.vue?vue&type=template&id=4313c1c0&"
import script from "./KorrespondenzTemplate.vue?vue&type=script&lang=js&"
export * from "./KorrespondenzTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports